export default function updateThreshold (cart) {
 
    
    // get threshold set in settings
    const threshold = parseInt(document.querySelector('.js-threshold').dataset.threshold)

    // get current amount in the cart
    const current_amount = (cart.total_price / 100)

    // get the diff
    const diff = (current_amount / threshold)

    const temp = document.querySelector('.js-temperature')
    const difference = document.querySelector('.js-difference')

    const difference_block = document.querySelector('.js-difference-block')
    const difference_success = document.querySelector('.js-difference-success')

    if (current_amount > threshold) {
        difference_block.style.display = 'none'
        difference_success.style.display = 'block'
        temp.style.width = '100%'
    } else {
        difference_success.style.display = 'none'
        difference_block.style.display = 'block'
        temp.style.width = (diff * 100) + '%'
        difference.innerHTML = '$' + (threshold - current_amount)
    }    

}
  